import compose from "recompose/compose";
import Seo from "./seo";
import Url from "./url";
import Schema from "./schema";
import alignment from "./alignment";
import Background from "./background";
import Conversion from "./conversion";

export default compose(Schema, Seo, Conversion, Url, Background, alignment);
